/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import createNewAddressApi from '../../../apis/my-addresses-apis/createNewAddressApi';
import LoadingModal from '../../../common/loading-modal/LoadingModal';
import userRouterLinks from '../../../components/app/user-routes/uesRouterLinks';
import CustomMap from '../../../components/custom-map/CustomMap';
import UserContext from '../../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import checkRes from '../../../utils/checkRes';
import errorNotification from '../../../utils/errorNotification';
import successNotification from '../../../utils/successNotification';
import './NewAddressForm.scss';

const NewAddressForm = ({ fetchedAddress, isLoadingAddress }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { i18n, t } = useTranslation();
  const {
    handleSubmit,
    watch,
    // setError,
  } = useForm({
    // resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: {
    }
  });

  const { user } = useContext(UserContext);

  const [selectedLocation, setSelecectedLocation] = React.useState({
    lat: '',
    lng: ''
  });
  const [selectedAddress, setSelectedAddress] = React.useState('');
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const customApiRequest = useCustomApiRequest();
  const [cancelCount, setCancelCount] = useState(0);
  // handle Initial values
  useEffect(() => {
    if (fetchedAddress && params?.addressId) {
      setSelecectedLocation({
        lat: fetchedAddress.lat ? Number(fetchedAddress.lat) : '',
        lng: fetchedAddress.lng ? Number(fetchedAddress.lng) : ''
      });
    }
  }, [fetchedAddress, cancelCount]);

  // handle cancel
  const handleCancel = () => {
    setCancelCount((prev) => prev + 1);
  };

  const onSubmit = (data) => {

    const formData = new FormData();
    if (selectedLocation?.lat) formData.append('lat', selectedLocation.lat);
    if (selectedLocation?.lng) formData.append('lng', selectedLocation.lng);
    formData.append("address_ar", selectedAddress)
    formData.append("address_en", selectedAddress)

    setIsSubmittingForm(true);
    if (!fetchedAddress) {
      customApiRequest(
        createNewAddressApi(formData, user?.token, i18n.language),
        (res) => {
          setIsSubmittingForm(false);
          if (checkRes(res)) {
            successNotification({
              title: t('successTitle'),
              message: res?.data?.message || t('successMessage')
            });

            navigate(userRouterLinks?.myAddresses);
          } else {
            errorNotification({
              title: t('errorTitle'),
              message: res?.data?.message
                ? res.data.message
                : 'حاول فى وقت لاحق'
            });
          }
        },
        (error) => {
          setIsSubmittingForm(false);
          errorNotification({
            title: t('errorTitle'),
            message: 'حاول فى وقت لاحق'
          });
        }
      );
    } else {
      formData.append('address_id', params?.addressId);
      customApiRequest(
        createNewAddressApi(formData, user?.token, i18n.language, true),
        (res) => {
          setIsSubmittingForm(false);
          if (checkRes(res)) {
            navigate(userRouterLinks?.myAddresses);
            successNotification({
              title: t('successTitle'),
              message: 'تم تعديل البيانات بنجاح'
            });
          } else {
            errorNotification({
              title: t('errorTitle'),
              message: res?.data?.message
                ? res.data.message
                : 'حاول فى وقت لاحق'
            });
          }
        },
        (error) => {
          setIsSubmittingForm(false);
          errorNotification({
            title: t('errorTitle'),
            message: 'حاول فى وقت لاحق'
          });
        }
      );
    }
  };

  const [form] = Form.useForm();

  if (isLoadingAddress) {
    return (
      <div
        className="custom-container"
        style={{
          marginTop: 92,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <LoadingOutlined style={{ fontSize: 24 }} spin />
      </div>
    );
  }

  return (
    <Form
      className="custom-shared-form new-address-form"
      form={form}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <div className="form-body">
        <CustomMap
          width="100%"
          height="400px"
          selectedLocation={selectedLocation}
          setSelecectedLocation={setSelecectedLocation}
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          isDraggable
          hasAutoComplete
        />
      </div>
      <div className="save-cancel-btns">
        <Button
          className="submit-btn"
          htmlType="submit"
          type="primary"
          // icon={<LoginOutlined />}
          loading={isSubmittingForm}
        >
          {t('newAddressForm.submit_btn.label')}
        </Button>
        <button onClick={handleCancel} type="button" className="cancel-btn">
          {t('user_settings_form.cancelBtn')}
        </button>
      </div>
      {isSubmittingForm && <LoadingModal />}
    </Form>
  );
};

export default NewAddressForm;
